// extracted by mini-css-extract-plugin
module.exports = {"bold":"wz_wy"};